import { z } from 'zod';
export const woStatusEnum = z.enum(['open', 'assigned', 'in_progress', 'completed', 'cancelled']);
export const woPriorityEnum = z.enum(['low', 'medium', 'high', 'critical']);
export const createWorkOrderSchema = z.object({
    title: z.string().trim().min(1, 'Title is required'),
    description: z.string().optional(),
    priority: woPriorityEnum.default('medium'),
    site_id: z.string().uuid({ message: 'Site is required' }),
    location_id: z.string().uuid().optional(),
    asset_id: z.string().uuid().optional(),
    due_date: z.string().optional(),
});
export const updateWorkOrderSchema = z.object({
    title: z.string().trim().min(1).optional(),
    description: z.string().optional(),
    priority: woPriorityEnum.optional(),
    location_id: z.string().uuid().optional(),
    asset_id: z.string().uuid().optional(),
    due_date: z.string().optional(),
});
export const assignWorkOrderSchema = z
    .object({
    assigned_to_user_id: z.string().uuid().optional(),
    assigned_to_team_id: z.string().uuid().optional(),
})
    .refine((d) => d.assigned_to_user_id || d.assigned_to_team_id, {
    message: 'Provide a user or team to assign',
});
export const addCommentSchema = z.object({
    text: z.string().trim().min(1, 'Comment cannot be empty'),
});
//# sourceMappingURL=work-order.schemas.js.map